import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  PHONE_VALIDATE,
  EMAIL_VALIDATE,
  DEFAULT_VALIDATION,
  PASSWORD_VALIDATE,
  VALIDATE_USER_ID,
  ADDRESS_VALIDATE,
  USER_EXIST,
  NAME_VALIDATE
} from "../../../validation";
import { Form, Button, InputGroup, Row } from "react-bootstrap";
import { isUserExist } from "../../../actions/signup.action";
import {
  createUserAction,
  getRolesByIdAction,
  getUsersListAction,
  getGroupRolesForUser,
  getGroupsForUserAction
} from "../../../actions/userManagement.action";
import { debounce, get } from "lodash";
import { bindActionCreators } from "redux";
import { isValidArray, getLocalstorage, truncateData } from "../../../helper";
import { modifyDataForCreateUser } from "../helper";
import { ERROR_MSG, STATUS } from "../../../constant";
import { LoaderPage } from "../../../component/Loader";
import { toast } from "react-toastify";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import { AutoSuggestSelect } from "../../../component/AutoSuggestSelect";
import TermsCondition from "../../footer/TermsConditions";
import PrivacyPolicy from "../../footer/PrivacyPolicy";
import { userSecurityKeyV2 } from "../../../actions/common.action";
import { JSEncrypt } from "jsencrypt/lib";
import { successToastStyle, errorToastStyle } from "../../../customToast";
import handleInputUserName from "./handleInputChange";
import { TrendingUpRounded } from "@material-ui/icons";
export class CreateUserForm extends Component {
  constructor(props) {
    super(props);
    //this.modalRef = React.createRef();
    this.state = {
      userId: "",
      telCode: "",
      mobileNumber: "",
      email: "",
      password: "",
      confirmPassword: "",
      name: "",
      pasted: false,
      designation: "",
      address: "Noida",
      errors: { roles: { error: false, message: false } },
      type: "password",
      groupId: "",
      groupRoles: [],
      submitBtnText: "REGISTER",
      dataChangeStatus: false,
      roles: [],
      showOrganization: false,
      passwordMatched: false,
      disableEditRole: false,
      iigAccess: false,
      dataUnsaved: false,
      allowPrompt: true
    };
  }

  componentDidMount() {
    const { groups, isEdit, groupData, getGroupsForUserAction } = this.props;
    document.addEventListener("mousedown", this.handleClickOutside);
    !isValidArray(groups) && getGroupsForUserAction(undefined);
    if (isEdit) {
      this.setState({
        userId: get(groupData, "userID", ""),
        name: get(groupData, "name", ""),
        designation: get(groupData, "designation", ""),
        email: get(groupData, "email", ""),
        mobileNumber: get(groupData, "mobileNumber", ""),
        disableEditRole: get(groupData, "disableEditRole", false)
      });
    }
  }

  componentWillUnmount() {
    // Clean up the event listener
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = event => {
    const { togglePopUp } = this.props;
    const { dataUnsaved, allowPrompt } = this.state;

    // Check if the click was outside the modal
    const modalRef = this.props.userModalRef && this.props.userModalRef.current;
    const isOutsideModal = modalRef && !modalRef.contains(event.target);

    // Check if the click was on the vertical scrollbar
    const isClickOnScrollbar =
      event.clientX > window.innerWidth - 7 &&
      (event.clientY >= 0 && event.clientY <= window.innerHeight);

    // If the click is outside the modal and not on the scrollbar
    if (isOutsideModal && !isClickOnScrollbar) {
      console.log(
        "Clicked outside the modal, but modal will not close.",
        dataUnsaved
      );
      if (dataUnsaved && allowPrompt && event.button === 0) {
        event.preventDefault();
        const confirmLeave = window.confirm(
          "You have unsaved changes, are you sure you want to leave?"
        );

        if (confirmLeave) {
          togglePopUp();
          return;
        }
      }
    }
  };

  handleChange = event => {
    const { name, value } = event.target;

    const data = {
      [name]: value
    };
    // if (name === "userId") {
    //   data[name] = value.trim();
    // }
    // if (name === "designation") {
    //   data["designation"] = value;
    // }
    this.setState({
      ...data,
      dataChangeStatus: true,
      dataUnsaved: true
    });
  };

  handleUserNameChange = event => {
    let { errors } = this.state;
    let pasted = this.state.pasted;
    let userName = this.state.name;
    let nameInputValue = event.target.value;
    if (pasted) {
      errors.nameValid = NAME_VALIDATE(nameInputValue);
      userName = truncateData(nameInputValue);
      this.setState({
        name: userName
      });
    } else {
      let currentNameValue = this.state.name;
      errors.nameValid = NAME_VALIDATE(nameInputValue);
      if (currentNameValue.length < 30 || nameInputValue.length < 31) {
        this.setState({
          name: nameInputValue
        });
      }
    }

    this.setState({
      pasted: false,
      dataUnsaved: true
    });
  };

  handleUserNamePaste = event => {
    this.setState({
      pasted: true,
      dataUnsaved: true
    });
  };

  handleIsUserExist = async event => {
    const { userId, errors } = this.state;
    const errorRef = { ...errors };
    const response = await isUserExist(undefined, { userId });
    if (response && response.data && !response.data.status) {
      errorRef.userIdValid = USER_EXIST(true, userId, "user");
      errorRef.userIdValidExist = errorRef.userIdValid;
      this.setState({
        errors: errorRef
      });
    } else {
      errorRef.userIdValid = USER_EXIST(false, userId, "user");
      errorRef.userIdValidExist = errorRef.userIdValid;
      this.setState({
        errors: errorRef
      });
    }
  };

  handleIsMobileNoExist = async event => {
    const { mobileNumber, errors } = this.state;
    const errorRef = { ...errors };
    const response = await isUserExist(undefined, { mobileNumber });
    if (response && response.data && !response.data.status) {
      errorRef.phoneValid = USER_EXIST(true, mobileNumber, "Mobile Number");
      errorRef.phoneValidExist = errorRef.phoneValid;
      this.setState({
        errors: errorRef
      });
    } else {
      errors.phoneValid = USER_EXIST(false, mobileNumber, "Mobile Number");
      errorRef.phoneValidExist = errorRef.phoneValid;
      this.setState({
        errors: errorRef
      });
    }
  };

  handleIsEmailExist = async event => {
    const { email, errors } = this.state;
    const errorRef = { ...errors };
    const response = await isUserExist(undefined, { email });
    if (response && response.data && !response.data.status) {
      errorRef.emailValid = USER_EXIST(true, email, "Email");
      errorRef.emailValidExist = errorRef.emailValid;
      this.setState({
        errors: errorRef
      });
    } else {
      errorRef.emailValid = USER_EXIST(false, email, "Email");
      errorRef.emailValidExist = errorRef.emailValid;
      this.setState({
        errors: errorRef
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    const oldProps = this.props;
    console.log(oldProps.formSaved);
    if (
      !nextProps.mobileNumber !== "" &&
      oldProps.mobileNumber !== nextProps.mobileNumber
    ) {
      this.setState({ mobileNumber: nextProps.mobileNumber });
    }
    if (!nextProps.email !== "" && oldProps.email !== nextProps.email) {
      this.setState({ email: nextProps.email });
    }
  }

  validateField = async (fieldName, value) => {
    let {
      errors,
      userId,
      mobileNumber,
      email,
      password,
      confirmPassword,
      name,
      designation,
      dataChangeStatus,
      rolesList,
      defaultSelected,
      alternateMobileNumber,
      organisation,
      showOrganization
    } = this.state;
    switch (fieldName) {
      case "userId":
        // if (!errors.userIdValid) {
        //   errors.userIdValid = {};
        // }
        // errors.userIdValid.error = false;
        errors.userIdValid = VALIDATE_USER_ID(value, "User ID");
        if (errors.userIdValid.error === false) {
          errors.userIdValidExist = {};
          errors.userIdValidExist.error = false;
          errors.userIdValidExist.message = "";
          this.handleIsUserExist();
        }
        break;
      case "mobileNumber":
        errors.phoneValid = PHONE_VALIDATE(value);
        if (errors.phoneValid.error === false) {
          errors.phoneValidExist = {};
          errors.phoneValidExist.error = false;
          errors.phoneValidExist.message = "";
          this.handleIsMobileNoExist();
        }
        break;
      case "alternateMobileNumber":
        if (value) {
          errors.alternateMobileNumber = PHONE_VALIDATE(value);
        } else {
          delete errors.alternateMobileNumber;
        }
        break;
      case "email":
        //console.log("email only");
        errors.emailValid = EMAIL_VALIDATE(value);
        if (errors.emailValid.error === false) {
          errors.emailValidExist = {};
          errors.emailValidExist.error = false;
          errors.emailValidExist.message = "";
          this.handleIsEmailExist();
        }
        // console.log("handleIsEmailExist errors1", errors);
        break;
      case "password":
        errors.passwordValid = PASSWORD_VALIDATE(value);
        break;
      case "confirmPassword":
        errors.confirmPasswordValid = PASSWORD_VALIDATE(value, password);
        break;
      case "name":
        errors.nameValid = {
          error: !value,
          message: !value && "Field is required"
        };
        break;
      case "address":
        errors.addressValid = ADDRESS_VALIDATE(value);
        break;
      case "designation":
        errors.designation = {
          error: !value,
          message: !value && "Field is required"
        };
        break;
      default:
        // errors.userIdValid =
        //   userId === ""
        //     ? DEFAULT_VALIDATION(value, "User ID")
        //     : VALIDATE_USER_ID(value, "User ID");
        // console.log("default case");
        errors.userIdValid = VALIDATE_USER_ID(userId, "User ID");
        errors.phoneValid = PHONE_VALIDATE(mobileNumber);
        errors.emailValid = EMAIL_VALIDATE(email);
        errors.passwordValid = PASSWORD_VALIDATE(password);
        if (alternateMobileNumber) {
          errors.alternateMobileNumber = PHONE_VALIDATE(alternateMobileNumber);
        } else {
          delete errors.alternateMobileNumber;
        }
        errors.confirmPasswordValid = PASSWORD_VALIDATE(
          confirmPassword,
          password
        );
        errors.nameValid = {
          error: !name,
          message: !name && "Field is required"
        };
        errors.orgValid = {
          error: showOrganization && !organisation,
          message: showOrganization && !organisation && "Field is required"
        };
        errors.designation = {
          error: !designation,
          message: !designation && "Field is required"
        };
        errors.roles = {
          error:
            isValidArray(rolesList) &&
            !rolesList.filter(value => value.checked).length,
          message: "Field is required"
        };
        errors.groupId = {
          error: !defaultSelected,
          message: ERROR_MSG.DEFAULT_MSG
        };
        if (dataChangeStatus && errors.emailValid.error === false) {
          console.log("In dataChangeStatus", dataChangeStatus);
          // this.handleIsUserExist();
          // this.handleIsMobileNoExist();
          this.handleIsEmailExist();
          // console.log("handleIsEmailExist errors", errors);
          // this.setState({
          //   dataChangeStatus: false,
          // });
        }
        if (dataChangeStatus && errors.phoneValid.error === false) {
          console.log("In dataChangeStatus", dataChangeStatus);
          // this.handleIsUserExist();
          this.handleIsMobileNoExist();
          //console.log("handleIsMobileNoExist errors", errors);
          // this.handleIsEmailExist();
          // this.setState({
          //   dataChangeStatus: false,
          // });
        }
        if (dataChangeStatus && errors.userIdValid.error === false) {
          console.log("In dataChangeStatus", dataChangeStatus);
          this.handleIsUserExist();
          // this.handleIsMobileNoExist();
          //this.handleIsEmailExist();
          // this.setState({
          //   dataChangeStatus: false,
          // });
        }
        break;
    }
    this.setState({
      errors: { ...errors }
    });
  };

  checkForMatched = confirmPassword => {
    let { password } = this.state;
    this.setState({
      passwordMatched: confirmPassword && confirmPassword === password
    });
  };

  validateForm = () => {
    let { errors, showOrganization } = this.state;
    let {
      passwordValid,
      phoneValid,
      emailValid,
      userIdValid,
      confirmPasswordValid,
      nameValid,
      orgValid,
      phoneValidExist,
      emailValidExist,
      userIdValidExist,
      groupId,
      roles,
      alternateMobileNumber: alternateMobileNumberError,
      designation
    } = errors;
    console.log("In validateForm", errors, errors.emailValidExist);
    if (alternateMobileNumberError && alternateMobileNumberError.error) {
      return false;
    }

    if (showOrganization) {
      if (orgValid && orgValid.error) {
        return false;
      }
    }

    if (
      // passwordValid &&
      // passwordValid.error &&
      // phoneValid &&
      // phoneValid.error &&
      // emailValid &&
      // emailValid.error &&
      // userIdValid &&
      // userIdValid.error &&
      // confirmPasswordValid &&
      // confirmPasswordValid.error &&
      // nameValid &&
      // nameValid.error &&
      // groupId &&
      // groupId.error &&
      // roles &&
      // roles.error &&
      !passwordValid.error &&
      !phoneValid.error &&
      !emailValid.error &&
      !userIdValid.error &&
      !confirmPasswordValid.error &&
      !phoneValidExist.error &&
      !emailValidExist.error &&
      !userIdValidExist.error &&
      !nameValid.error &&
      !groupId.error &&
      !roles.error &&
      !designation.error
    ) {
      console.log("Are you here1");
      return true;
    }
    console.log("Are you here2");
    return false;
  };

  showPassword = e => {
    e.preventDefault();
    e.stopPropagation();
    const { type } = this.state;
    this.setState({
      type: type === "password" ? "text" : "password"
    });
  };

  handleOtpModal = async event => {
    event.preventDefault();
    this.validateField();
    let isValidData = this.validateForm();
    console.log("isValidData", isValidData);
    if (isValidData) {
      this.openConfirmationAlert();
    } else {
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
    }
  };

  restrictSpace = event => {
    let key = event ? event.which : window.event.keyCode;
    if (key === 32) {
      event.preventDefault();
    }
  };

  onChange = (value, key, index) => {
    const { getGroupRolesForUser } = this.props;
    const customProps = {};
    if (key === "groupId") {
      this.setState(
        {
          rolesList: [],
          dataUnsaved: true
        },
        async () => {
          const response = await getGroupRolesForUser(undefined, value);
          if (response) {
            const { data, status, message } = response;
            status
              ? toast.success(
                  <p className="toast-text-alignment">{message}</p>,
                  successToastStyle
                )
              : toast.error(
                  <p className="toast-text-alignment">{message}</p>,
                  errorToastStyle
                );
            isValidArray(data.data) &&
              data.data.forEach(roles => (roles.checked = roles.preselect));
            isValidArray(data.data) &&
              this.setState({
                rolesList: data.data
              });
            this.getFilteredData({ sortData: data.data });
          }
        }
      );
    } else {
      this.setState(async prevState => {
        prevState[key] = prevState[key] || [];
        const indexId = prevState[key].indexOf(value);
        indexId !== -1
          ? prevState[key].splice(indexId, 1)
          : prevState[key].push(value);
        prevState[key] = [...prevState[key]];
        return {
          [key]: value,
          ...customProps,
          dataUnsaved: true
        };
      });
    }
  };

  onError = (value, key) => {
    this.setState(prevState => {
      const error = isValidArray(prevState[key])
        ? { error: !prevState[key].length, message: ERROR_MSG.DEFAULT_MSG }
        : value;
      return {
        errors: {
          ...prevState.errors,
          [key]: error
        }
      };
    });
  };

  openConfirmationAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
      allowPrompt: !prevState.allowPrompt
    }));
  };

  onIIGAccess = () => {
    this.setState(prevState => ({
      iigAccess: !prevState.iigAccess,
      dataUnsaved: true
    }));
  };

  getSecurityKey = async () => {
    let { userSecurityKeyV2 } = this.props;
    const { password } = this.state;
    try {
      await userSecurityKeyV2();
      const { securityKeyData } = this.props;
      if (get(securityKeyData, "id")) {
        let userID = get(securityKeyData, "id");
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(get(securityKeyData, "key"));
        const encryptedPassword = encrypt.encrypt(password);
        this.setState({ encryptedPassword, userID });
        this.onSubmit();
      } else {
        toast.error(
          <p className="toast-text-alignment">Please check your credentials</p>,
          errorToastStyle
        );
      }
    } catch (e) {
      console.log(`Error ${e.message}`);
    }
  };

  onSubmit = async () => {
    const {
      createUserDispatch,
      getUsersListDispatch,
      togglePopUp,
      callApiOnSuccess
    } = this.props;
    const {
      userId,
      mobileNumber,
      email,
      name,
      designation,
      rolesList,
      groupId,
      organisation,
      alternateMobileNumber,
      encryptedPassword,
      userID,
      showOrganization,
      iigAccess
    } = this.state;
    const postData = {
      designation,
      email,
      mobileNumber,
      name,
      password: encryptedPassword,
      userID: userId,
      key: userID,
      rolesList,
      groupId,
      organisation,
      alternateMobileNumber,
      iigAccess
    };
    this.setState({ isApiLoading: STATUS.LOADING });
    const params = modifyDataForCreateUser(postData);
    if (!params.alternateMobileNumber) delete params.alternateMobileNumber;
    if (!showOrganization) delete params.organisation;
    const registerResponse = await createUserDispatch(undefined, params);
    togglePopUp();
    callApiOnSuccess();
    if (registerResponse) {
      const { status, message } = get(registerResponse, "data", {});
      status
        ? toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )
        : toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
      status && getUsersListDispatch(undefined);
      this.openConfirmationAlert();
      this.setState({
        isApiLoading: STATUS.SUCCESS,
        dataUnsaved: false
        // allowPrompt: false,
      });
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  getFilteredData = sortedListingArr => {
    this.setState({
      sortedListingArr: get(sortedListingArr, "sortData", []),
      isSearching: get(sortedListingArr, "isSearching"),
      searchRoles: get(sortedListingArr, "value")
    });
  };

  onSelectRoles = value => {
    this.setState(prevState => {
      value.checked = !value.checked;
      const selectedRoles = prevState.rolesList.filter(value => {
        return value.checked;
      });
      return {
        rolesList: prevState.rolesList,
        errors: {
          ...prevState.errors,
          roles: {
            error: !selectedRoles.length,
            message: !selectedRoles.length && ERROR_MSG.DEFAULT_MSG
          }
        }
      };
    });
  };

  onAutoSuggestChange = value => {
    const { groups } = this.props;
    this.setState({
      autoSuggestApiLoading: STATUS.LOADING,
      defaultSelected: value.searchedText,
      groupsList: []
    });
    get(this.autoSuggestApi, "cancel") && this.autoSuggestApi.cancel();
    this.autoSuggestApi = debounce(() => {
      let searchedText = get(groups, "data", []);
      if (value.searchedText) {
        const regEx = RegExp(value.searchedText, "i");
        searchedText = get(groups, "data", []).filter(value => {
          return regEx.test(value.name);
        });
      }
      this.setState({
        groupsList: searchedText
      });
    }, 1000);
    this.autoSuggestApi();
  };

  onOptionClick = value => {
    this.onChange(value.id, "groupId");
    this.setState(prevState => ({
      defaultSelected: value.name,
      groupId: value.id,
      errors: {
        ...prevState.errors,
        groupId: {
          error: !value,
          message: !value && ERROR_MSG.DEFAULT_MSG
        }
      }
    }));
    if (value.id === 54 || value.description === "Project Proponent Group") {
      this.setState({
        showOrganization: true
      });
    } else {
      this.setState({
        showOrganization: false
      });
    }
  };

  closeReadBannerModal = () => {
    this.setState({ isBannerModalVisible: false });
  };

  showReadBannerModal = key => {
    this.setState({ isBannerModalVisible: true, bannerContent: key });
  };
  proponentBlur = value => {};
  render() {
    const { groups } = this.props;
    const {
      type,
      submitBtnText,
      userId,
      mobileNumber,
      email,
      password,
      confirmPassword,
      name,
      designation,
      bannerContent,
      isBannerModalVisible,
      errors,
      showAlert,
      isApiLoading,
      sortedListingArr,
      organisation,
      defaultSelected,
      groupsList,
      alternateMobileNumber,
      showOrganization,
      passwordMatched,
      disableEditRole,
      iigAccess,
      dataUnsaved
    } = this.state;

    let isPermission = false;
    const user = getLocalstorage("user");

    const userPermission = (sortedListingArr || []).find(
      value => get(value, "permission") === true
    );

    if (userPermission) {
      isPermission = true;
    }

    return (
      <div
        className="register-inner create-user-register-inner"
        //ref={this.modalRef}
      >
        <LoaderPage isLoading={isApiLoading === STATUS.LOADING} />
        <Form onSubmit={this.handleOtpModal} noValidate className="signup-form">
          <ConfirmationComponent
            show={showAlert}
            isLoading={isApiLoading}
            modalClass={"confirmation-modal"}
            saveHandler={this.getSecurityKey}
            closeHandler={this.openConfirmationAlert}
            content={"Are you sure you want to do this?"}
          />
          <Form.Group controlId="userId">
            <Form.Label className="label-style">User ID</Form.Label>
            <span className="required">*</span>
            <Form.Control
              name="userId"
              type="text"
              value={userId}
              maxLength="100"
              onChange={this.handleChange}
              onBlur={() => this.validateField("userId", userId)}
              isInvalid={
                get(errors, "userIdValid.error") ||
                get(errors, "userIdValidExist.error")
              }
              placeholder="Create User ID"
              className="field-width"
            />
            <Form.Control.Feedback type="invalid">
              {/* {errors.userIdValid && errors.userIdValid.error
                ? errors.userIdValid.message
                : null}
              {errors.userIdValidExist &&
              errors.userIdValidExist.error &&
              !errors.userIdValid.error
                ? errors.userIdValidExist.message
                : null} */}
              {get(errors, "userIdValid.message") ||
                get(errors, "userIdValidExist.message") ||
                null}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="name">
            <Form.Label className="label-style"> Name</Form.Label>
            <span className="required">*</span>
            <Form.Control
              name="name"
              type="text"
              value={name}
              onPaste={this.handleUserNamePaste}
              onChange={this.handleUserNameChange}
              onBlur={() => this.validateField("name", name)}
              isInvalid={errors.nameValid && errors.nameValid.error}
              placeholder="Enter Name"
              className="field-width"
            />
            <Form.Control.Feedback type="invalid">
              {get(errors, "nameValid.message", null)}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="designation">
            <Form.Label className="label-style"> Designation </Form.Label>
            <span className="required">*</span>
            <Form.Control
              name="designation"
              keyName="designation"
              type="text"
              value={designation}
              onChange={this.handleChange}
              onBlur={() => this.validateField("designation", designation)}
              isInvalid={get(errors, "designation.error")}
              placeholder="Enter Designation"
              className="field-width"
            />
            <Form.Control.Feedback type="invalid">
              {get(errors, "designation.message", null)}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="email">
            <Form.Label className="label-style"> Email </Form.Label>
            <span className="required">*</span>
            <Form.Control
              name="email"
              type="text"
              value={email}
              onChange={this.handleChange}
              onBlur={() => this.validateField("email", email)}
              isInvalid={
                get(errors, "emailValid.error") ||
                get(errors, "emailValidExist.error")
              }
              placeholder="example@gmail.com"
              className="field-width"
            />
            <Form.Control.Feedback type="invalid">
              {get(errors, "emailValid.message") ||
                get(errors, "emailValidExist.message") ||
                null}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="mobileNumber">
            <Form.Label className="label-style"> Mobile Number</Form.Label>
            <span className="required">*</span>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text
                  id="inputGroupPrepend"
                  className="mobile-number"
                >
                  +91
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                name="mobileNumber"
                type="text"
                maxLength="10"
                value={mobileNumber}
                onChange={this.handleChange}
                onBlur={() => this.validateField("mobileNumber", mobileNumber)}
                isInvalid={
                  get(errors, "phoneValid.error") ||
                  get(errors, "phoneValidExist.error")
                }
                placeholder="Enter Mobile Number"
                className="mobile-field-width"
              />
              <Form.Control.Feedback type="invalid">
                {get(errors, "phoneValid.message") ||
                  get(errors, "phoneValidExist.message") ||
                  null}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          <Form.Group controlId="mobileNumber">
            <Form.Label className="label-style">
              Alternate Mobile Number
            </Form.Label>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text
                  id="inputGroupPrepend"
                  className="mobile-number"
                >
                  +91
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                name="alternateMobileNumber"
                type="text"
                maxLength="10"
                value={alternateMobileNumber}
                onChange={this.handleChange}
                onBlur={() => {
                  this.validateField(
                    "alternateMobileNumber",
                    alternateMobileNumber
                  );
                }}
                isInvalid={
                  errors.alternateMobileNumber &&
                  errors.alternateMobileNumber.error
                }
                placeholder="Enter Alternative Mobile Number"
                className="mobile-field-width"
              />
              <Form.Control.Feedback type="invalid">
                {errors.alternateMobileNumber &&
                errors.alternateMobileNumber.error
                  ? errors.alternateMobileNumber.message
                  : null}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          <Form.Group controlId="password">
            <Form.Label className="label-style"> Password </Form.Label>
            <span className="required">*</span>
            <Form.Control
              name="password"
              type={type}
              value={password}
              onChange={this.handleChange}
              onBlur={() => {
                this.validateField("password", password);
                this.checkForMatched(confirmPassword);
              }}
              onKeyPress={this.restrictSpace}
              isInvalid={get(errors, "passwordValid.error")}
              placeholder="Create Password"
              className="field-width"
            />
            <Form.Control.Feedback type="invalid">
              {get(errors, "passwordValid.message", null)}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="confirmPassword">
            <Form.Label className="label-style"> Retype Password </Form.Label>
            <span className="required">*</span>
            <Form.Control
              name="confirmPassword"
              type={type}
              value={confirmPassword}
              onChange={this.handleChange}
              onBlur={() => {
                this.validateField("confirmPassword", confirmPassword);
                this.checkForMatched(confirmPassword);
              }}
              onKeyPress={this.restrictSpace}
              isInvalid={get(errors, "confirmPasswordValid.error")}
              placeholder="Confirm Password"
              className="field-width"
            />
            <Form.Control.Feedback type="invalid">
              {get(errors, "confirmPasswordValid.message", null)}
            </Form.Control.Feedback>
            {passwordMatched ? (
              <span className="password-matched">Password Matched</span>
            ) : null}
          </Form.Group>

          <Form.Group className="category">
            <Form.Label className="label-style">
              Select Group
              <span className="required">*</span>
            </Form.Label>
            <AutoSuggestSelect
              isLoading={false}
              isCreateUserSearch={true}
              defaultSelected={defaultSelected}
              options={
                isValidArray(groupsList) ? groupsList : get(groups, "data")
              }
              onChange={this.onAutoSuggestChange}
              onOptionClick={this.onOptionClick}
              delay={10}
              redBorder={true}
              onBlur={this.proponentBlur}
            />

            {get(errors, "groupId.error", null) ? (
              <span className="error-text">
                {get(errors, "groupId.message", null)}
              </span>
            ) : null}
          </Form.Group>

          {showOrganization ? (
            <Form.Group controlId="organisation">
              <Form.Label>Organization</Form.Label>
              <span className="required">*</span>
              <Form.Control
                name="organisation"
                type="text"
                value={organisation}
                onChange={this.handleChange}
                onBlur={() => this.validateField("organisation", organisation)}
                isInvalid={errors.orgValid && errors.orgValid.error}
                placeholder="Enter Organization"
              />
              <Form.Control.Feedback type="invalid">
                {get(errors, "orgValid.message", null)}
              </Form.Control.Feedback>
            </Form.Group>
          ) : null}

          {get(user, "groupCategory") == "PMG" ||
          get(user, "groupCategory") == "CENTRAL" ||
          get(user, "groupCategory") == "CENTRAL_DEPARTMENT" ? (
            <Form.Check
              className={`form-checkbox iig-checkbox  ${
                iigAccess ? "checked" : ""
              }`}
            >
              <Form.Check.Input
                type="checkbox"
                className="iig-access-checkbox"
              />
              <Form.Check.Label
                className="d-flex  iig-access"
                onClick={this.onIIGAccess}
              >
                <div className="pt-1">CRIP Access</div>
              </Form.Check.Label>
            </Form.Check>
          ) : null}

          {isValidArray(sortedListingArr) ? (
            <React.Fragment>
              <Form.Group as={Row} controlId="category" className="group-roles">
                <Form.Label className="select-group roles-select-group">
                  Roles
                  <span className="required">*</span>
                </Form.Label>
                <div className="select-role">
                  {(sortedListingArr || []).map((value, index) => {
                    if (get(value, "permission") !== true) {
                      return (
                        <div
                          value={get(value, "id")}
                          className="selected-group-role checkbox-style roles "
                        >
                          <Form.Label aria-label={get(value, "roleName")} />
                          <Form.Check
                            type="checkbox"
                            value={get(value, "roleId")}
                            id={get(value, "roleName")}
                            label={get(value, "roleName")}
                            onClick={e => {
                              this.onSelectRoles(value);
                            }}
                            className={`form-checkbox ${
                              value.checked ? "checked" : ""
                            }`}
                          />
                        </div>
                      );
                    }
                  })}
                </div>
                {get(errors, "roles.error", null) ? (
                  <span className="error-text">
                    {get(errors, "roles.message", null)}
                  </span>
                ) : null}
              </Form.Group>
            </React.Fragment>
          ) : null}

          {isValidArray(sortedListingArr) && isPermission && (
            <React.Fragment>
              <Form.Group
                as={Row}
                controlId="category"
                className="group-roles permission-group"
              >
                <Form.Label className="select-group permission-select-group">
                  Permissions
                </Form.Label>
                <div className="select-role">
                  {(sortedListingArr || []).map((value, index) => {
                    if (get(value, "permission")) {
                      return (
                        <div
                          value={get(value, "id")}
                          className="selected-group-role checkbox-style roles"
                        >
                          <Form.Label aria-label={get(value, "roleName")} />
                          <Form.Check
                            type="checkbox"
                            value={get(value, "roleId")}
                            id={get(value, "roleName")}
                            label={get(value, "roleName")}
                            onClick={e => {
                              this.onSelectRoles(value);
                            }}
                            className={`form-checkbox ${
                              value.checked ? "checked" : ""
                            } ${disableEditRole ? "disabled-checkbox" : null}`}
                            disabled={disableEditRole}
                          />
                        </div>
                      );
                    }
                  })}
                </div>
                {get(errors, "roles.error", null) ? (
                  <span className="error-text">
                    {get(errors, "roles.message", null)}
                  </span>
                ) : null}
              </Form.Group>
            </React.Fragment>
          )}

          <Button
            variant="primary"
            type="submit"
            className="btn-orange full-width edit-create-user-btn"
            onClick={this.handleOtpModal}
          >
            {submitBtnText}
          </Button>
          <div className="term-use create text-center">
            By clicking "Register" I agree to{" "}
            <span onClick={() => this.showReadBannerModal("termsConditions")}>
              Terms of Service
            </span>{" "}
            &{" "}
            <span onClick={() => this.showReadBannerModal("privacyPolicy")}>
              Privacy Policy
            </span>
            .
          </div>
        </Form>

        {bannerContent === "termsConditions" ? (
          <TermsCondition
            show={isBannerModalVisible}
            closeModal={this.closeReadBannerModal}
          />
        ) : null}
        {bannerContent === "privacyPolicy" ? (
          <PrivacyPolicy
            show={isBannerModalVisible}
            closeModal={this.closeReadBannerModal}
          />
        ) : null}
      </div>
    );
  }
}

CreateUserForm.propTypes = {
  history: PropTypes.shape({})
};

CreateUserForm.defaultProps = {
  history: {}
};

function mapStateToProps(state) {
  return {
    groups: state.userManagementReducer.groups,
    rolesList: state.userManagementReducer.rolesList,
    isApiLoading: state.userManagementReducer.isApiLoading,
    securityKeyData: state.loginReducer.securityKeyData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getRolesDispatch: getRolesByIdAction,
      createUserDispatch: createUserAction,
      getUsersListDispatch: getUsersListAction,
      getGroupRolesForUser,
      getGroupsForUserAction,
      userSecurityKeyV2
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateUserForm);
